import { Skeleton, Row, Col } from "antd";

const PageLoader = ({
  rows = 4,
  cards = 4,
  showHero = true,
  showTabs = true,
  showCards = true,
  title = "",
}) => {
  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-border/50 bg-card overflow-hidden">
        {showHero && (
          <Skeleton.Image active style={{ width: "100%", height: 144, borderRadius: 0 }} />
        )}

        <div className="p-6">
          <Skeleton
            active
            avatar={{ size: 56, shape: "square" }}
            title={title ? { width: 200 } : false}
            paragraph={{ rows: 1 }}
          />
          {title && (
            <p className="text-sm text-muted-foreground mt-1">{title}</p>
          )}
        </div>

        {showTabs && (
          <div className="border-t border-border/50 px-6 py-3 flex gap-6">
            {[80, 64, 72].map((w, i) => (
              <Skeleton.Input key={i} active size="small" style={{ width: w }} />
            ))}
          </div>
        )}

        <div className="p-6 space-y-6">
          {showCards && (
            <Row gutter={[16, 16]}>
              {Array.from({ length: cards }).map((_, i) => (
                <Col key={i} xs={24} sm={12} lg={6}>
                  <div className="rounded-2xl border border-border/50 p-4 space-y-3">
                    <Skeleton.Input active size="small" style={{ width: "60%" }} />
                    <Skeleton.Input active size="large" style={{ width: "40%" }} />
                  </div>
                </Col>
              ))}
            </Row>
          )}

          <Skeleton active paragraph={{ rows }} />
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
